import { Component, Input, Output, EventEmitter, OnInit, HostListener } from '@angular/core';

@Component({
  selector: 'bz-time-picker',
  templateUrl: './time-picker.component.html',
  styleUrls: ['./time-picker.component.scss']
})
export class TimePickerComponent implements OnInit {
  @Input() dateInput: Date;
  @Output() timeChange = new EventEmitter<Date>();
  @Input() isVisible: boolean = false;
  @Input() showIcon: boolean = true;
  

  hours: string;
  minutes: string;
  hoursArray: string[] = Array.from({ length: 24 }, (_, i) => i.toString().padStart(2, '0'));
  minutesArray: string[] = Array.from({ length: 60 }, (_, i) => i.toString().padStart(2, '0'));

  dropdownOpenHours: boolean = false;
  dropdownOpenMinutes: boolean = false;
  hoveredMinute: string | null = null;
  hoveredHour: string | null = null;


  ngOnInit() {
  }

  ngOnChanges() {
    if (this.dateInput) {
      this.hours = this.dateInput.getHours().toString().padStart(2, '0');
      this.minutes = this.dateInput.getMinutes().toString().padStart(2, '0');
    }
  }

  updateTime() {
    const updatedTime = new Date(this.dateInput);
    updatedTime.setHours(Number(this.hours));
    updatedTime.setMinutes(Number(this.minutes));
    this.timeChange.emit(updatedTime);
  }

  toggleDropdownHours() {
    this.dropdownOpenMinutes = false;
    this.dropdownOpenHours = !this.dropdownOpenHours;
  }

  toggleDropdownMinutes() {
    this.dropdownOpenHours = false;
    this.dropdownOpenMinutes = !this.dropdownOpenMinutes;
  }

  selectMinute(minute: string) {
    this.minutes = minute;
    this.updateTime();
  }

  selectHour(hours: string) {
    this.hours = hours;
    this.updateTime();
  }
}

